module.exports = __webpack_public_path__ + "img/ironhelm.6bfd928f.png";